import React, { useState, useEffect, useRef } from "react";
import { Box, TextField, Stack, Card, InputAdornment } from "@mui/material";
import emoji from "emoji-dictionary";
import SearchIcon from "@mui/icons-material/Search";

const EmojiPopover = ({ handleReactionClick, handleCloseEmojiPopover }) => {
  const [filter, setFilter] = useState("");
  const allEmojis = emoji.names;

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleFilterChange = (event) => {
    setFilter(event.target.value.toLowerCase());
  };

  const filteredEmojis = allEmojis.filter((emojiName) => emojiName.includes(filter));

  return (
    <Card
      sx={{
        p: 2,
        height: "400px",
        width: "400px",
        backgroundColor: "#28282a",
        display: "flex",
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Find the right reaction..."
        value={filter}
        inputRef={inputRef}
        onChange={handleFilterChange}
        sx={{
          mb: 2,
          "& .MuiOutlinedInput-input": {
            color: "#fff",
          },
          "& .MuiInputLabel-root": {
            color: "#fff",
          },
          "& .MuiInputAdornment-root": {
            color: "#cecece",
            fontSize: "1.25rem",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon sx={{ fontSize: "1.5rem" }} />
            </InputAdornment>
          ),
        }}
      />
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack direction="row" sx={{ flexWrap: "wrap" }}>
          {filteredEmojis.map((emojiName) => (
            <Box
              key={emojiName}
              role="img"
              aria-label={emojiName}
              onClick={(event) => {
                handleReactionClick(`:${emojiName}:`);
                if (!event.shiftKey) {
                  handleCloseEmojiPopover();
                }
              }}
              sx={{
                px: "0.25rem",
                fontSize: "1.4rem",
                "&:hover": { cursor: "pointer" },
              }}
            >
              {emoji.getUnicode(emojiName)}
            </Box>
          ))}
        </Stack>
      </Box>
    </Card>
  );
};

export default EmojiPopover;
